module.exports = __webpack_public_path__ + "img/ping2.45e07f4a.png";